export default "__VITE_ASSET__BLopKsjA__"